export default "__VITE_ASSET___5$V_HEB__"